import * as React from "react";

export type CalloutVariant = "info" | "error" | "success";

export interface CalloutProps {
  children: React.ReactNode;
  variant?: CalloutVariant;
  icon?: React.ReactNode;
  centered?: boolean;
}

const variantStyles: Record<CalloutVariant, { bg: string; color: string; border?: string }> = {
  info: { bg: "#EBF5FF", color: "#1E429F" },
  error: { bg: "#FDF2F2", color: "#9B1C1C", border: "1px solid #F9B8B8" },
  success: { bg: "#F3FAF7", color: "#03543F", border: "1px solid #BCF0DA" },
};

const InfoIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0, marginTop: 1 }}
    aria-hidden
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </svg>
);

export function Callout({ children, variant = "info", icon, centered }: CalloutProps) {
  const styles = variantStyles[variant];
  return (
    <div
      style={{
        padding: "10px 14px",
        background: styles.bg,
        borderRadius: 8,
        fontSize: variant === "error" ? 13 : 12,
        color: styles.color,
        display: "flex",
        gap: 8,
        alignItems: centered ? "center" : "flex-start",
        justifyContent: centered ? "center" : undefined,
        textAlign: centered ? "center" : undefined,
        border: styles.border,
      }}
      role={variant === "error" ? "alert" : undefined}
    >
      {icon ?? (variant === "info" ? <InfoIcon /> : null)}
      <span style={{ flex: 1, minWidth: 0 }}>{children}</span>
    </div>
  );
}
